import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { Router } from '@angular/router';
import { ApiParameterService } from '../parameter';
import { tap } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class ApiMaintenanceService {
  public updates: ReplaySubject<object> = new ReplaySubject(1);
  public previousEnabled?: boolean;
  public enabled = false;
  public enabledStrict = false;
  public title = '';
  public content = '';
  private interval?: any;
  private isRunning = false;

  constructor(
    private _apiParameter: ApiParameterService,
    @Inject(PLATFORM_ID) private _platformId: object,
    private _router: Router,
  ) {}

  check(navigate = false) {
    this.isRunning = true;

    return this._apiParameter
      .values([
        'MAINTENANCE_ENABLED',
        'MAINTENANCE_STRICT_ENABLED',
        'MAINTENANCE_TITLE',
        'MAINTENANCE_CONTENT',
      ])
      .pipe(
        tap((result: any) => {
          this.previousEnabled = this.enabled;

          this.enabled = result.data['MAINTENANCE_ENABLED'];
          this.enabledStrict = result.data['MAINTENANCE_STRICT_ENABLED'];
          this.title = result.data['MAINTENANCE_TITLE'];
          this.content = result.data['MAINTENANCE_CONTENT'];

          this.updates.next({
            enabled: this.enabled,
            enabledStrict: this.enabledStrict,
            title: this.title,
            content: this.content,
          });

          this.runInterval();

          navigate && this.navigate();
        }),
      );
  }

  navigate() {
    const isMaintenanceUrl = this._router.url.startsWith('/maintenance');
    if (!this.previousEnabled && this.enabled && !isMaintenanceUrl) {
      this._router.navigate(['/maintenance']).then();
    } else if (!this.enabled && isMaintenanceUrl) {
      this._router.navigate(['/']).then();
    }
  }

  run() {
    if (!this.isRunning) {
      this.check().subscribe();
    }
  }

  runInterval() {
    if (!this.interval && isPlatformBrowser(this._platformId)) {
      this.interval = setInterval(
        () => {
          this.check(true).subscribe();
        },
        5 * 60 * 1000,
      );
    }
  }

  clearInterval() {
    this.interval && clearInterval(this.interval);
  }
}
